"use client"

import * as React from "react"
import { KeyMetrics } from "@/components/key-metrics"
import { EVAL_DASHBOARD_KPI_STRIP_CLASS } from "@/lib/evaluation-dashboard-a11y"
import { Button } from "@/components/ui/button"
import { DashboardSectionTitle } from "@/components/dashboard-section-heading"
import {
  QUALITY_ACCREDITATION,
  QUALITY_CLOSING_LOOP,
  evaluationQualityClosingLoopMetrics,
} from "@/lib/mock/evaluation-quality-dashboard"

export function QualityClosingLoop() {
  const metrics = React.useMemo(
    () => evaluationQualityClosingLoopMetrics(QUALITY_CLOSING_LOOP),
    [],
  )

  return (
    <section aria-labelledby="quality-loop-heading" className="flex flex-col gap-4">
      <DashboardSectionTitle as="h2" id="quality-loop-heading">
        From feedback to improvement
      </DashboardSectionTitle>

      <KeyMetrics
        variant="cards"
        size="sm"
        metrics={metrics}
        showHeader={false}
        metricsSingleRow
        className={EVAL_DASHBOARD_KPI_STRIP_CLASS}
      />

      <ul className="flex flex-col gap-3">
        {QUALITY_CLOSING_LOOP.items.map(item => (
          <li
            key={item.id}
            className="rounded-xl border border-border/60 bg-muted/20 px-4 py-3 text-sm"
          >
            <p className="font-medium text-foreground">{item.source}</p>
            <p className="mt-1 text-muted-foreground">{item.learnerSaid}</p>
            <p className="mt-2 flex items-center gap-2 text-foreground">
              {item.status === "done" ? (
                <i className="fa-solid fa-circle-check text-chart-2" aria-hidden="true" />
              ) : (
                <i className="fa-light fa-circle-half-stroke text-[color:var(--chart-4)]" aria-hidden="true" />
              )}
              {item.outcome}
            </p>
          </li>
        ))}
      </ul>
    </section>
  )
}

export function QualityAccreditationBlock() {
  const acc = QUALITY_ACCREDITATION

  return (
    <section
      aria-labelledby="quality-accreditation-heading"
      className="rounded-2xl border border-border/60 bg-card p-5"
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex flex-col gap-2">
          <DashboardSectionTitle as="h2" id="quality-accreditation-heading">
            Accreditation evidence
          </DashboardSectionTitle>
          <p className="text-3xl font-bold tabular-nums text-foreground">{acc.readyPercent}% ready</p>
          <p className="text-sm tabular-nums text-muted-foreground">
            {acc.complete} / {acc.total} evidence requirements complete
          </p>
          <p className="text-xs text-muted-foreground">{acc.frameworks.join(" · ")}</p>
        </div>
        <Button size="sm" className="shrink-0">
          View evidence
        </Button>
      </div>

      <ul className="mt-4 flex flex-col gap-1.5 text-sm text-muted-foreground">
        {acc.needsAttention.map(item => (
          <li key={item.label} className="flex items-start gap-2">
            <i className="fa-light fa-circle-exclamation mt-0.5 text-[color:var(--chart-4)]" aria-hidden="true" />
            {item.label}
          </li>
        ))}
      </ul>
    </section>
  )
}
